__turbopack_context__.v({
  "button": "Button-module-scss-module__cJNsyq__button",
});
